import { render } from "./FooterMenu.vue?vue&type=template&id=f7de470e"
import script from "./FooterMenu.vue?vue&type=script&lang=js"
export * from "./FooterMenu.vue?vue&type=script&lang=js"

import "./FooterMenu.vue?vue&type=style&index=0&id=f7de470e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__